export const aboutContent = {
  id: "about",
  title: "About",
  content: {
    type: "ABOUT",
    details:
      "I am a Full Stack Web Developer recently graduated from Lambda School. I enjoy building cool projects and using my skills to help others see their dreams fullfilled. I am passionate about code and things relating to technology. I enjoy learning new things and solving challenging problems.",
  },
};
